var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNextivityLogoColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 554 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #036;\n      }\n\n      .cls-1, .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #4faee0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NEXTIVITY"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    className: "cls-1",
    points: "540.36 27.56 531.28 37.49 521.86 27.56 512.27 27.56 527.68 44 527.68 60.1 534.88 60.1 534.88 44 550.29 27.56 540.36 27.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    className: "cls-1",
    points: "467.75 27.56 467.75 34.81 480.42 34.81 480.42 60.1 487.62 60.1 487.62 34.81 500.29 34.81 500.29 27.56 467.75 27.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    className: "cls-1",
    points: "443.1 60.1 450.29 60.1 450.29 27.56 443.1 27.56 443.1 60.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    className: "cls-1",
    points: "416.8 27.56 406.61 48.23 396.24 27.56 388.3 27.56 404.57 60.1 408.67 60.1 424.95 27.56 416.8 27.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    className: "cls-1",
    points: "362.96 60.1 370.15 60.1 370.15 27.56 362.96 27.56 362.96 60.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    className: "cls-1",
    points: "312.96 27.56 312.96 34.81 325.63 34.81 325.63 60.1 332.82 60.1 332.82 34.81 345.49 34.81 345.49 27.56 312.96 27.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    className: "cls-1",
    points: "290.75 27.56 281.61 38.4 272.47 27.56 263.3 27.56 277.04 43.83 263.3 60.1 272.47 60.1 281.61 49.26 290.75 60.1 299.95 60.1 286.2 43.83 299.95 27.56 290.75 27.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    className: "cls-1",
    points: "217.07 27.56 217.07 60.1 249.6 60.1 249.6 52.9 224.6 52.9 224.6 47.2 240.01 47.2 240.01 40.01 224.6 40.01 224.6 34.75 248.23 34.75 248.23 27.56 217.07 27.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    className: "cls-1",
    points: "192.37 27.56 192.37 47.64 171.89 27.56 167.07 27.56 167.07 60.1 174.3 60.1 174.3 40.38 175.4 41.43 194.64 60.1 199.6 60.1 199.6 27.56 192.37 27.56"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "X-Logo",
    className: "cls-2",
    d: "M5.08,4.27H43.67c.55,0,1.07,.22,1.45,.6l24.73,24.75c.78,.78,2.04,.8,2.85,.06l.06-.06L97.49,4.88c.39-.39,.91-.6,1.45-.6h38.67c.76,0,1.37,.61,1.37,1.37,0,.36-.14,.71-.4,.97l-31.18,31.27c-.53,.54-1.4,.54-1.94,0-.26-.26-.4-.61-.4-.97v-9.99c0-.76-.61-1.37-1.37-1.37-.36,0-.71,.14-.97,.4l-16.6,16.59c-.8,.8-.8,2.1,0,2.91l16.6,16.59c.54,.53,1.4,.53,1.94,0,.26-.26,.4-.61,.4-.97v-9.99c0-.76,.61-1.37,1.37-1.37,.36,0,.71,.14,.97,.4l31.18,31.27c.53,.54,.53,1.4,0,1.94-.26,.26-.6,.4-.97,.4h-38.67c-.55,0-1.07-.22-1.46-.61l-24.72-24.88c-.78-.78-2.04-.81-2.84-.07l-.07,.07-24.72,24.88c-.39,.39-.91,.61-1.46,.61H5.08c-.76,0-1.37-.61-1.37-1.37,0-.36,.14-.71,.4-.97L39.89,45.45c.8-.8,.8-2.1,0-2.9L4.11,6.61c-.53-.54-.53-1.4,0-1.94,.26-.26,.6-.4,.97-.4Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextivityLogoColor);
export default __webpack_public_path__ + "static/media/nextivity_logo_color.045273c3f0c85c4c550fafcbe2cb328e.svg";
export { ForwardRef as ReactComponent };